import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center border border-white/10 bg-zinc-900/50 rounded p-12 text-center min-h-[200px]">
          <div className="text-zinc-400 text-sm uppercase tracking-widest mb-4">
            Something went wrong in this section
          </div>
          <div className="text-zinc-600 text-xs font-mono mb-6 max-w-md break-all">
            {this.state.error?.message || "Unknown error"}
          </div>
          <button
            onClick={this.handleRetry}
            className="px-6 py-2 bg-[#FF3B30] text-white text-xs uppercase tracking-widest font-bold hover:bg-[#FF3B30]/80 transition-colors"
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
